import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 100px 20px;
  background: transparent;
`;

export const Banner = styled.div`
  width: 100%;
  max-width: 1200px;
  min-height: 420px;
  background: linear-gradient(135deg, #030014 0%, #050510 50%, #08081A 100%);
  border: 1px solid rgba(133, 76, 230, 0.1);
  border-radius: 40px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 40px 20px;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at 20% 30%, rgba(133, 76, 230, 0.1) 0%, transparent 40%),
                radial-gradient(circle at 80% 70%, rgba(0, 210, 255, 0.05) 0%, transparent 40%);
    pointer-events: none;
  }
`;

export const WingsLogo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
  z-index: 2;
`;

export const Headline = styled.h2`
  font-size: 42px;
  font-weight: 800;
  color: #FFFFFF;
  text-align: center;
  line-height: 1.1;
  text-transform: uppercase;
  letter-spacing: -0.01em;
  margin: 0;
  z-index: 2;

  span {
    display: block;
    margin-top: 8px;
    color: rgba(255, 255, 255, 0.5);
    font-weight: 700;
  }

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

export const CTAButton = styled.div`
  background: #FFFFFF;
  padding: 12px 28px;
  border-radius: 50px;
  color: #000000;
  font-size: 15px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 30px 0;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  cursor: pointer;
  z-index: 3;

  &:hover {
    transform: translateY(-5px) scale(1.05);
    box-shadow: 0 10px 20px rgba(255, 255, 255, 0.15);
  }

  .arrow {
    width: 24px;
    height: 24px;
    background: #000000;
    color: #FFFFFF;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const OpenToWorkSeal = styled.div`
  position: absolute;
  top: 50%;
  right: 10%;
  width: 100px;
  height: 100px;
  z-index: 2;

  .rotating-ring {
    animation: ${rotate} 20s linear infinite;
  }

  @media (max-width: 1100px) {
    display: none;
  }
`;

export const FooterText = styled.div`
  text-align: center;
  z-index: 2;
  margin-top: 10px;
  
  p {
    margin: 5px 0;
    font-size: 15px;
    font-weight: 600;
    color: #FFFFFF;
  }
  
  span {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.4);
    display: block;
    margin-top: 4px;
  }
`;
